import styled, { css } from "styled-components";
import theme from "../../theme/feedback";

/**
 * A row of mutually exclusive options — a dashboard period, a billing term.
 * Touch-first: every option is visible at once, nothing to open.
 *
 *   <Segmented $fill>
 *     <SegButton $active={term === "month"} onClick={...}>Monthly</SegButton>
 *   </Segmented>
 *
 * $fill stretches the group across its container and gives each option an
 * equal, finger-sized share.
 */
export const Segmented = styled.div`
  display: inline-flex;
  background: ${theme.color.surfaceAlt};
  border-radius: ${theme.radius.md};
  padding: 3px;
  gap: 2px;

  ${(props) =>
    props.$fill &&
    css`
      display: flex;
      width: 100%;
      box-sizing: border-box;

      & > button {
        flex: 1;
        min-height: 42px;
      }
    `}
`;

export const SegButton = styled.button`
  border: none;
  cursor: pointer;
  font-family: ${theme.font.family};
  font-size: ${theme.font.sizeSm};
  font-weight: ${theme.font.weightSemibold};
  letter-spacing: 0.3px;
  padding: 6px 14px;
  border-radius: ${theme.radius.sm};
  transition: background 0.2s ease, color 0.2s ease;
  color: ${(props) =>
    props.$active ? theme.color.surface : theme.color.primary};
  background: ${(props) =>
    props.$active ? theme.color.primary : "transparent"};

  &:hover {
    background: ${(props) =>
      props.$active ? theme.color.primary : "rgba(0, 24, 126, 0.08)"};
  }
`;
